import { Dispatch } from "redux";
import api from "../../api/api";
import {
    createCourseEmbeddings as setCreateEmbeddingsMessage,
    setloading,
    seterror,
    resetCreateCourseEmbeddings,
} from "../reducers/createCourseEmbeddingsReducer";

// Triggers backend embeddings creation for a course
const triggerCreateEmbeddings = (token: string, courseId: number) => async (
    dispatch: Dispatch
) => {
    dispatch(setloading(true));
    try {
        const response = await api.post(
            `/api/embeddings/create/`,
            { bulk_process: true, course_id: courseId },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                },
            }
        );

        dispatch(setloading(false));

        if (response?.status === 200 || response?.data?.status === 200) {
            dispatch(setCreateEmbeddingsMessage(response?.data?.message ?? "Embeddings triggered"));
        } else {
            dispatch(seterror(response?.data?.message ?? "Failed to trigger embeddings"));
        }
    } catch (error: any) {
        dispatch(seterror(error?.response?.data?.message ?? "Failed to trigger embeddings"));
        dispatch(setloading(false));
    }
};

// Create embeddings for individual files (used by GoogleDriveUpload)
const createEmbeddingsAPI = (id: string, token: string) => async (dispatch: Dispatch) => {
    dispatch(setloading(true));

    try {
        const response = await api.post(
            `/api/embeddings/create/`,
            { file_id: id },
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );

        dispatch(setloading(false));

        if (response.data.status === 200) {
            dispatch(setCreateEmbeddingsMessage(response?.data?.message));
        }
    } catch (error: any) {
        dispatch(seterror(error?.response?.data?.message));
        dispatch(setloading(false));
    }
};

export { triggerCreateEmbeddings, createEmbeddingsAPI, resetCreateCourseEmbeddings };